import { Component, OnInit } from '@angular/core';
import mockedFeatures from './mockedFeatures.json';
import {DataCatalogueService} from "./services/data-catalogue.service";
import {CatalogSummary} from "./model/catalog-summary";
import {FeatureSummary} from "./model/feature-summary";

interface IFeatureOption {
  label: string;
  value: string;
}

@Component({
  selector: 'data-catalogue',
  templateUrl: './data-catalogue.component.html',
  styleUrls: ['./data-catalogue.component.css']
})
export class DataCatalogueComponent implements OnInit {

    features: IFeatureOption[] = [];
    searchText: string = '';
    latestCatalogVersion: CatalogSummary;

    constructor(private dataCatalogueService: DataCatalogueService) {}

    filteredFeatures(): IFeatureOption[] {
        const search = this.searchText.toLowerCase();
        return this.features.filter(f => f?.label?.toLowerCase().includes(search));
    }

    getCatalogs(): void {
        this.dataCatalogueService.listCatalogs().subscribe((res: CatalogSummary[]) => {
            this.latestCatalogVersion = res?.[0];
            this.getFeatures();
        });
    }

    getFeatures(): void {
        if (this.latestCatalogVersion) {
            this.dataCatalogueService.getFeatures(this.latestCatalogVersion.uuid)
                .subscribe((res: FeatureSummary[]) => {
                  const array: IFeatureOption[] = [];

                  res?.forEach((el: FeatureSummary) => {
                     array.push({
                         label: el?.name?.split(":")?.[1],
                         value: el?.name
                     });
                  });

                  this.features = array;
                });
        }
    }

    ngOnInit() {
        this.getCatalogs();
    }
}